import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';
import remarkHtml from 'remark-html';

interface MarkdownLayoutProps {
    markdown: string;
}

const MarkdownLayout: React.FC<MarkdownLayoutProps> = ({ markdown }) => (
    <ReactMarkdown
        rehypePlugins={[rehypeRaw]}
        remarkPlugins={[remarkGfm, remarkHtml]}
        components={{
            h2: () => null,
            p: ({ node, ...props }) => (
                <p
                    className="text-ink-800 dark:text-ink-100 leading-relaxed text-[15px] my-4 first:mt-0 last:mb-0"
                    {...props}
                />
            ),
            a: ({ node, href, ...props }) => (
                <a
                    href={href}
                    target={href && /^https?:/.test(href) ? '_blank' : undefined}
                    rel="noreferrer"
                    className="text-accent dark:text-accent-soft no-underline hover:underline decoration-accent/50 underline-offset-2"
                    {...props}
                />
            ),
            strong: ({ node, ...props }) => (
                <strong className="text-ink-900 dark:text-ink-50 font-medium" {...props} />
            ),
            em: ({ node, ...props }) => (
                <em className="text-ink-800 dark:text-ink-100 italic" {...props} />
            ),
            ul: ({ node, ...props }) => (
                <ul className="list-none pl-0 my-0 space-y-3 [counter-reset:item]" {...props} />
            ),
            li: ({ node, children, ...props }) => (
                <li
                    className="[counter-increment:item] flex gap-4 items-baseline text-ink-800 dark:text-ink-100 text-[15px] leading-relaxed before:content-[counter(item,decimal-leading-zero)] before:font-mono before:text-[11px] before:tracking-wider before:text-accent dark:before:text-accent-soft before:shrink-0"
                    {...props}
                >
                    <span className="flex-1">{children}</span>
                </li>
            ),
        }}
    >
        {markdown}
    </ReactMarkdown>
);

export default MarkdownLayout;
